import { render, staticRenderFns } from "./task-new-page.html?vue&type=template&id=6f35b6b4&"
import script from "./task-new-page.js?vue&type=script&lang=js&"
export * from "./task-new-page.js?vue&type=script&lang=js&"
import style0 from "./task-new-page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports